import type { CSSProperties } from 'react';
import type { AvatarId } from '@guess/protocol';
import { AVATAR_IDS, AvatarGlyph } from './avatars';
import { cx } from './cx';
import s from './ui.module.scss';

/**
 * Le jeton d'un joueur : une icone sur un carre de sa couleur.
 *
 * Sans choix (avatar ou couleur), on retombe sur des valeurs deduites du
 * SIEGE — deterministe, jamais aleatoire, pour qu'un joueur qui n'a rien
 * configure ait quand meme une identite stable d'un ecran a l'autre.
 */
export interface AvatarProps {
  avatarId?: AvatarId | undefined;
  /** Couleur explicite (1-8), ou deduite de `seatIndex` si absente. */
  colorId?: number | undefined;
  seatIndex: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string | undefined;
}

export function Avatar({ avatarId, colorId, seatIndex, size = 'md', className }: AvatarProps) {
  // Repli deterministe : le Nieme avatar de la liste pour le Nieme siege,
  // jamais le meme avatar pour tout le monde par defaut.
  const glyph = avatarId ?? AVATAR_IDS[seatIndex % AVATAR_IDS.length]!;
  const seat = colorId !== undefined ? colorId : (seatIndex % 8) + 1;

  return (
    <span
      className={cx(s.avatar, s[`avatarSize-${size}`], className)}
      style={{ '--seat': `var(--c-seat-${seat})` } as CSSProperties}
    >
      <AvatarGlyph avatarId={glyph} className={s.avatarGlyph} />
    </span>
  );
}
